import validator from "validator";
class DataUtils {
    trimFields(values) {
        let newValues = {};
        for (var key in values) {
            var value = values[key];
            if (value !== null) {
                if (typeof value === "string") {
                    newValues[key] = value.trim();
                }
                else {
                    newValues[key] = value;
                }
            }
        }
        return newValues;
    }

    removeEmptyFields(values) {
        let newValues = {};
        for (var key in values) {
            var value = values[key];
            if (value !== null) {
                if (typeof value === "string") {
                    value = value.trim();
                    if (value !== "") {
                        newValues[key] = value;
                    }
                }
                else {
                    newValues[key] = value;
                }
            }
        }
        return newValues;
    }

    isOneValueSpecified(field1, field2) {
        if (field1 && field1.trim() !== "") {
            return true;
        }
        if (field2 && field2.trim() !== "") {
            return true;
        }
    }

    isLengthValid(field, length, required) {
        if (!field || field.trim() === "") {
            if (required) {
                return false;
            }
            return true;
        }
        else if (field.length > length) {
            return false;
        }
        return true;
    }

    isUSZipValid(zip, required) {
        let regex = /^\d{5}(-\d{4})?$/;
        if (!zip || zip === "") {
            if (required) {
                return false;
            }
            return true;
        }
        else if (!regex.test(zip)) {
            return false;
        }
        return true;
    }

    isEmailValid(field, required) {
        if (!field || field.trim() === "") {
            if (required) {
                return false;
            }
            return true;
        }
        else if (!validator.isEmail(field)) {
            return false;
        }
        return true;
    }

    isNumberValid(field, required) {
        if (!field || field.trim() === "") {
            if (required) {
                return false;
            }
            return true;
        }
        else if (!validator.isNumeric(field)) {
            return false;
        }
        return true;
    }

    isWebsiteValid(field, required) {
        var websiteOptions = {};
        websiteOptions.require_protocol = true;
        if (!field || field.trim() === "") {
            if (required) {
                return false;
            }
            return true
        }
        else if (!validator.isURL(field, websiteOptions)) {
            return false;
        }
        return true;
    }

    // This expects a 10 digit number
    formatPhoneNumber(number) {
        if (!number || number === "" || number === 0) {
            return "";
        }
        let cleaned = ('' + number).replace(/\D/g, '');
        let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return '(' + match[1] + ') ' + match[2] + '-' + match[3];
        }
        return "";
    }

    shortenString(field, length) {
        if (!field || field.trim() === "") {
            return "";
        }
        if (field.length > length) {
            return field.substring(0, length - 3) + "...";
        }
        return field;
    }

    toUSCurrencyRounded(number) {
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

        return formatter.format(number);
    }

    isEmpty(field) {
        if (!field) {
            return true;
        }
        else if (field.trim() === "") {
            return true;
        }
        else {
            return false;
        }
    }

    isNotEmpty(field) {
        if (!field) {
            return false;
        }
        else if (field.trim() === "") {
            return false;
        }
        else {
            return true;
        }
    }
}
export default new DataUtils();